import {LIMPAR_ULTIMOS_HISTORICOS_PRECO} from '../types';

export default function limparUltimosHistoricosPreco () {
    return {
        type: LIMPAR_ULTIMOS_HISTORICOS_PRECO
    }
}
